import React from "react";
import { connect } from "react-redux";
import { loadSimilarPosts } from "../../actions/postActions";
import HorizontalSlider from "../HorizontalSlider";
import RecommendedPost from "./components/RecommendedPost";
import { trackRecommendedCaseClick } from "../../services/mixpanel";

import "./index.css";
import { constructPostSlugPath } from "../../util";

const getRecommendedPostUrl = (recommendedPost, currentPost) =>
  `${constructPostSlugPath(recommendedPost)}?recommended_from=${currentPost._id}`;

const trackRecommendedPost = ({ currentPost, recommendedPost }) => () =>
  trackRecommendedCaseClick({ currentPost, recommendedPost });

const RecommendedPosts = ({ post: currentPost, actions, container = "" }) => {
  const loadMoreSimilarPosts = () => {
    actions.loadSimilarPosts(currentPost._id, { pagingToken: currentPost.similarPosts.pagingToken });
  };

  return (
    <div className={`recommended -${container}`}>
      <div className="title">
        <h2 className="text">Recommended Cases</h2>
        <hr className="divider" />
      </div>

      <HorizontalSlider
        loadMore={loadMoreSimilarPosts}
        isLoading={currentPost.similarPosts.isFetching}
        hasMore={currentPost.similarPosts.hasMore}
      >
        {currentPost.similarPosts.posts.map((post, index) => (
          <RecommendedPost
            key={post._id}
            post={post}
            onClick={trackRecommendedPost({ currentPost, recommendedPost: { ...post, index } })}
            postUrl={getRecommendedPostUrl(post, currentPost)}
          />
        ))}
      </HorizontalSlider>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  actions: {
    loadSimilarPosts: (postId, options) => dispatch(loadSimilarPosts(postId, options)),
  },
});

export default connect(null, mapDispatchToProps)(RecommendedPosts);



// WEBPACK FOOTER //
// ./src/components/RecommendedPosts/index.js